import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentSettings"] */ "/workspace/src/components/privacy/cookie-consent-banner.tsx");
